import axios from 'axios'

export const AdminCodeYearService = {
  /**
   * @param {*} status blank is for both status(published and inactive)
   * status = 1 ==> for inactive
   * status = 2 ==> for published
   */
  fetchCodeYearList (status = '') {
    if (status !== '') {
      return axios.get(`/api/v1/yearlist/${status}`)
    } else {
      return axios.get('/api/v1/yearlist')
    }
  },
  /**
   * edit code year record
   */
  editCodeYearItem (data) {
    return axios.post(`/api/v1/edityear`, JSON.stringify({
      year: data.year,
      status: data.status,
      userId: data.userId,
      id: data.id
    }))
  },
  /**
   * Add new code year record
   */
  addNewCodeYearItem (data) {
    return axios.post(`/api/v1/addyear`, JSON.stringify({
      year: data.year,
      status: data.status,
      userId: data.userId
    }))
  },
  validateCodeYearItem (data) {
    return axios.delete(`/api/v1/deleteyear`, { data: data })
  },
  deleteCodeYearItem (data) {
    return axios.delete(`/api/v1/deleteyear`, { data: data })
  }
}
